import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
import Map from './Map';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTree } from '@fortawesome/free-solid-svg-icons';
import { useLanguageStore } from '../store';
import { translations } from '../translations';

export default function Footer() {
  const language = useLanguageStore((state) => state.language);
  const t = translations[language];

  return (
    <footer className="bg-primary-900 dark:bg-gray-900 text-white transition-colors duration-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-semibold mb-4 flex items-center">
              <FontAwesomeIcon icon={faTree} className="text-primary-300 h-5 w-5 mr-2" />
              {t.footer.contact}
            </h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MapPin className="w-5 h-5 flex-shrink-0" />
                <span>Białogórne 5, 96-230 Biała Rawska</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <a href="mailto:iglakmierz@gmail.com" className="hover:text-primary-300">
                  iglakmierz@gmail.com
                </a>
              </div>
              <div className="flex flex-col space-y-2">
                <div className="flex items-center space-x-2">
                  <Phone className="w-5 h-5 flex-shrink-0" />
                  <a href="tel:696022651" className="hover:text-primary-300">696 022 651</a>
                </div>
                <div className="flex items-center space-x-2">
                  <Phone className="w-5 h-5 flex-shrink-0" />
                  <a href="tel:725285736" className="hover:text-primary-300">725 285 736</a>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-4 flex items-center">
              <FontAwesomeIcon icon={faTree} className="text-primary-300 h-5 w-5 mr-2" />
              {t.footer.openingHours.title}
            </h3>
            <div className="space-y-2">
              <p>{t.footer.openingHours.weekdays}</p>
              <p>{t.footer.openingHours.saturday}</p>
              <p>{t.footer.openingHours.sunday}</p>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-4 flex items-center">
              <FontAwesomeIcon icon={faTree} className="text-primary-300 h-5 w-5 mr-2" />
              {t.footer.location}
            </h3>
            <div className="h-48 bg-primary-800 dark:bg-gray-800 rounded-lg overflow-hidden">
              <Map />
            </div>
          </div>

        </div>

        <div className="mt-8 pt-8 border-t border-primary-800 dark:border-gray-700 text-center text-sm">
          <div className="flex items-center justify-center mb-2">
            <FontAwesomeIcon icon={faTree} className="text-primary-300 h-4 w-4 mr-2" />
            <span>Iglak Mierzejewski</span>
          </div>
          <div className="flex items-center justify-center gap-4 mb-2">
            <Link to="/regulamin" className="text-gray-400 hover:text-primary-300 transition-colors">
              {t.legal.termsFooter}
            </Link>
            <span className="text-gray-600">·</span>
            <Link to="/polityka-prywatnosci" className="text-gray-400 hover:text-primary-300 transition-colors">
              {t.legal.privacyFooter}
            </Link>
          </div>
          <p>&copy; {new Date().getFullYear()} Iglak Mierzejewski. {t.footer.rights}.</p>
        </div>
      </div>
    </footer>
  );
}